import React, { useContext } from 'react'
import { JourneyContext } from '../context/journeyContext'
import { getValueFromJourney } from '../services/helperFunctions'
import { lineCapital } from '../../shared/functions'

export default function ComponentTextParagraph(props) {
   const [journeyState, setJourneyState] = useContext(JourneyContext)
    return (
         <>
            <label className="inp-label">
            </label>
            <div dangerouslySetInnerHTML={{"__html":props.data.Content}}></div>
         </>
        )
}